const isDark = color => {
  const darkness =
    1 - (0.299 * color.r + 0.587 * color.g + 0.114 * color.b) / 255;
  return darkness > 0.4;
};

const hexToRgbObj = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b, alpha };
};

const normalizeHex = hex => {
  if (hex.length === 4) {
    return hex[0] + hex.substr(1).repeat(2);
  }
  return hex;
};

const isHexColor = hex =>
  typeof hex === 'string' &&
  hex.length === 7 &&
  !isNaN(parseInt(hex.substr(1), 16));

const colorLegible = color => {
  let colorTexto = '#fff';
  const normalizedHex = normalizeHex(color);
  if (isHexColor(normalizedHex) && !isDark(hexToRgbObj(normalizedHex))) {
    colorTexto = '#000';
  }
  return colorTexto;
};

export default colorLegible;
